import {createApp} from 'vue'
import RolesFormContent from './RolesFormContent'

const el = '.kb-component--roles-form-content'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((RolesFormContentDOM)=>{
            const component = createApp(RolesFormContent).use(Store)
            component.mount(RolesFormContentDOM)
        })
    }
}